import React from "react";
import cx from "classnames";
import { Image } from "src/components/image";
import { Reveal } from "src/components/reveal";
import styles from "./this-changes-everything.module.css";

interface ThisChangesEverythingProps {
  module: {
    headline?: string;
    items: [
      {
        _key: string;
        copy: string;
        graphic: {
          asset: {
            url: string;
          };
        };
      }
    ];
  };
}

export const ThisChangesEverything = ({
  module
}: ThisChangesEverythingProps) => {
  const { headline, items } = module;
  return (
    <div className={cx(styles.thisChangesEverything)}>
      <h2 className={cx("subhead ac", styles.headline)}>{headline}</h2>
      <div className={styles.items}>
        {items &&
          items.map((item, index) => (
            <Reveal key={item._key} delay={(index + 1) * 120}>
              <div className={styles.item}>
                <Image
                  className={styles.itemGraphic}
                  src={item.graphic.asset.url}
                  alt={item.copy}
                  width={100}
                />
                <p className={cx("ac body", styles.itemCopy)}>{item.copy}</p>
              </div>
            </Reveal>
          ))}
      </div>
    </div>
  );
};
